import { render } from "./SzDialog.vue?vue&type=template&id=c87a5d36"
import script from "./SzDialog.vue?vue&type=script&lang=ts"
export * from "./SzDialog.vue?vue&type=script&lang=ts"

import "./SzDialog.vue?vue&type=style&index=0&id=c87a5d36&lang=less"
script.render = render

export default script